document.addEventListener("DOMContentLoaded", () => {
    const modal = document.getElementById("inspirationModal");
    if (!modal) return;
    
    const modalImg = document.getElementById("modalImage");
    const closeBtn = modal.querySelector(".modal-close");
    const backdrop = modal.querySelector(".modal-backdrop");
    const items = document.querySelectorAll(".inspiration-grid .grid-item");

    items.forEach(item => {
        item.addEventListener("click", () => {
            const img = item.querySelector("img");
            if (img) {
                modalImg.src = img.src;
                modal.classList.add("is-active");
                document.body.style.overflow = "hidden"; // Prevent scrolling
            }
        });
    });

    const closeModal = () => {
        modal.classList.remove("is-active");
        document.body.style.overflow = "";
        setTimeout(() => {
            modalImg.src = "";
        }, 300); // clear after animation
    };

    closeBtn.addEventListener("click", closeModal);
    backdrop.addEventListener("click", closeModal);
});
